import React from 'react'
import PropTypes from 'prop-types'

import I18n from 'lib/i18n'
import ReputationData from 'lib/components/reputation-data'

const Reputation = ({ reputation, wrapperSpace, labelClassName, contentStyle = {}, className }) => (
  <div className={`widget ${className} ${wrapperSpace ? 'space' : 'nospace'} clearfix`}>
    <h3 className={`boxtitle line ${labelClassName || ''}`}>{I18n.t('profiles.show_right.online_reputation')}</h3>
    <div style={contentStyle}>
      <ReputationData data={reputation} showChecks />
    </div>
  </div>
)

Reputation.propTypes = {
  className: PropTypes.string,
  contentStyle: PropTypes.object,
  labelClassName: PropTypes.string,
  reputation: PropTypes.object,
  wrapperSpace: PropTypes.bool
}

export default Reputation
